import React from 'react';
import { parseCantidad, fmtNum } from '@/lib/recuentos';

const NumInput = ({ value, onChange, disabled, invalid, testId, placeholder, className = '' }) => (
  <input
    type="text"
    inputMode="decimal"
    autoComplete="off"
    value={value}
    disabled={disabled}
    placeholder={placeholder}
    onChange={(e) => onChange(e.target.value)}
    className={`h-12 rounded-lg border-2 px-3 text-lg font-semibold text-right outline-none transition-colors focus:border-orange-500 disabled:bg-slate-50 ${
      invalid ? 'border-red-400 bg-red-50' : 'border-slate-200'
    } ${className}`}
    data-testid={testId}
  />
);

const AltInputs = ({ item, v, onChange, disabled }) => {
  const total = (parseCantidad(v.packs) || 0) * item.factor_alternativa + (parseCantidad(v.sueltos) || 0);
  const hasAny = v.packs !== '' || v.sueltos !== '';
  return (
    <div className="flex items-end gap-2 flex-wrap justify-end">
      <label className="text-xs text-slate-500 flex flex-col">
        {item.unidad_alternativa} (×{fmtNum(item.factor_alternativa)})
        <NumInput value={v.packs} disabled={disabled} invalid={Number.isNaN(parseCantidad(v.packs))} onChange={(x) => onChange({ ...v, packs: x })} className="w-20" testId={`packs-${item.ingrediente_id}`} />
      </label>
      <label className="text-xs text-slate-500 flex flex-col">
        sueltos
        <NumInput value={v.sueltos} disabled={disabled} invalid={Number.isNaN(parseCantidad(v.sueltos))} onChange={(x) => onChange({ ...v, sueltos: x })} className="w-20" testId={`sueltos-${item.ingrediente_id}`} />
      </label>
      <div className="text-sm text-slate-600 pb-3 min-w-[70px] text-right" data-testid={`total-${item.ingrediente_id}`}>
        = <b>{hasAny ? fmtNum(Math.round(total * 1000) / 1000) : '—'}</b>
      </div>
    </div>
  );
};

export const IngredienteRow = ({ item, value, onChange, disabled }) => {
  const usesAlt = !!item.factor_alternativa;
  const counted = usesAlt ? value.packs !== '' || value.sueltos !== '' : value.cantidad !== '';
  const setZero = () => onChange(usesAlt ? { ...value, packs: '0', sueltos: '0' } : { ...value, cantidad: '0' });

  return (
    <div
      className={`rounded-xl border px-3 py-2.5 flex flex-wrap items-center gap-x-3 gap-y-2 ${counted ? 'bg-white border-green-200' : 'bg-white border-slate-200'}`}
      data-testid={`ingrediente-row-${item.ingrediente_id}`}
    >
      <div className="flex-1 min-w-[140px] flex items-center gap-3">
        <span className={`w-2 h-2 rounded-full shrink-0 ${counted ? 'bg-green-500' : 'bg-slate-300'}`} />
        <div className="min-w-0">
          <div className="font-medium text-slate-800 leading-tight">{item.nombre_justo}</div>
          <div className="text-xl font-bold text-orange-600 uppercase tracking-wide">{item.unidad}</div>
        </div>
      </div>
      <div className="flex items-center gap-2 justify-end ml-auto">
        {usesAlt ? (
          <AltInputs item={item} v={value} onChange={onChange} disabled={disabled} />
        ) : (
          <NumInput
            value={value.cantidad}
            disabled={disabled}
            placeholder="—"
            invalid={Number.isNaN(parseCantidad(value.cantidad))}
            onChange={(x) => onChange({ ...value, cantidad: x })}
            className="w-24"
            testId={`cantidad-${item.ingrediente_id}`}
          />
        )}
        {!disabled && (
          <button
            type="button"
            onClick={setZero}
            className="h-12 px-2 rounded-lg border border-slate-200 text-[11px] leading-tight font-semibold text-slate-600 hover:bg-slate-100 w-14"
            data-testid={`no-hay-${item.ingrediente_id}`}
          >
            No hay<br />= 0
          </button>
        )}
      </div>
    </div>
  );
};
